module.exports = __webpack_public_path__ + "img/BARBONI-LOGO.fe6eddde.png";